module.exports = __webpack_public_path__ + "img/give_share.1b286f26.png";